import { useQuery } from 'react-query';
import { axiosRequestHandler } from 'helpers/Requests';
import { IEVChargingPageContent } from 'interfaces/chargingLocator';

export default function useEVChargingPageContentData() {
  const queryKey = `/platform/api/v1/evChargingContent`;
  return useQuery<IEVChargingPageContent, Error>(
    queryKey,
    async () => {
      let { data } = await axiosRequestHandler(queryKey);
      return data as IEVChargingPageContent;
    },
    {
      staleTime: Infinity, //adding staleTime to avoid re fetching the endpoint each time the user refocus the page.
    }
  );
}
